import { Injectable } from '@angular/core';
import { RestService } from '../services/rest.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private restHttp: RestService
  ) { }

  public GETCustomer(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetPagableCustomer`);
  }
  public GETALLCustomerBYCityID(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllCustomers`);
  }

  public DeleteCustomer(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteCustomer?customerId=${id}`);
  }
  getCustomerbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Customer/${id}`);
  }
  public UpdateCustomer(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateCustomer`, model);
  }
  public CreateCustomerAddress(model) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/AddressInfo`, model);
  }
  public DeleteAddress(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteCustomerAddress?addressId=${id}`);
  }
  getCustomerAddressbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllAddressesCustomer?customerId=${id}`);
  }
  getCustomerFeedback(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllCustomerReviews?customerId=${id}`);
  }
  public GETAllCardsByCustomerId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/AllCustomerCard?customerId=${id}`);

  }
  public GETOrdersByCustomerId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CustomerOrderHistory?customerId=${id}`);

  }
}
